import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import 'react-toastify/dist/ReactToastify.css';
import { TermsAndPrivacy } from '../../../utils/termsAndPrivacy';


import {
  FormGroup,
  FormCheckbox,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

import './inAppOrder.scss';
import './msgOrder.scss';

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

//inport images
import {Redirect} from "react-router-dom";


let planPd = {
  m1000: {val:'m1000', name:"m-1000", label: "1,000", orgPrice: 12000, price: 12000, count: 1000, addCount:0 },
  m2000: {val:'m2000', name:"m-2000", label: "2,000", orgPrice: 24000, price: 24000, count: 2000, addCount:0 },
  m5000: {val:'m5000', name:"m-5000", label: "5,000", orgPrice: 63000, price: 60000, count: 5000, addCount:250 },
  m10000: {val:'m10000', name:"m-10000", label: "10,000", orgPrice: 132000, price: 120000, count: 10000, addCount:1000 },
  m20000: {val:'m20000', name:"m-20000", label: "20,000", orgPrice: 276000, price: 240000, count: 20000, addCount:3000 },
  m50000: {val:'m50000', name:"m-50000", label: "50,000", orgPrice: 720000, price: 600000, count: 50000, addCount:10000 },
}

@inject(({ teamUser }) => ({ authCheck: teamUser.authCheck, isLogin: teamUser.isLogin, me:teamUser.me,  updateInAppOrder:teamUser.updateInAppOrder, updateMsgOrder: teamUser.updateMsgOrder, checkOrder:teamUser.checkOrder, checkOrderShop: teamUser.checkOrderShop, freeEventApply: teamUser.freeEventApply }))
@inject(({ company }) => ({ getSalesReport: company.getSalesReport, getApplyShop:company.getApplyShop }))
@inject(({ common }) => ({ getDoc: common.getDoc }))

@observer
class MsgOrder extends Component {

  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250514-447465981&result=success
  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250510-447458880&result=success

  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250318-447327123&result=failss
  //https://orvad.owphew.co.kr/cafeMsgOrderReturnUrl?order_id=cafe24-20250318-447327123&result=success

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);
  //page
  @observable planPd = planPd;
  @observable redirectInfo = {
    is: false,
    pathname: '/orderEnd'
  }
  @observable orderInfo = {
    serviceAgree: false,
    privateAgree: false,
  };
  @observable noRefundAgg = false;

  // 약관 모달 — type: 'service' | 'private' | 'noRefund'
  @observable termsModal = {open: false, type: null};

  openTermsModal = (type) => { this.termsModal = {open: true, type}; };
  closeTermsModal = () => { this.termsModal = {open: false, type: null}; };


  constructor(props) {
    super(props);
    this.init()
  }


  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};

    }
  };

  onSelOrderItem = async (key) => {
    this.orderInfo = this.planPd[key];
  }

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
    }
  };

  onSubmit = async (event) => {
    let _this = this;
    event.preventDefault();
    if(!this.orderInfo.val) {
      alert('상품을 선택해 주세요.');
      return false;
    }
    else if(!this.orderInfo.serviceAgree) {
      alert('서비스 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.orderInfo.privateAgree) {
      alert('개인정보 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.noRefundAgg) {
      alert('환불 정책에 동의해 주세요.');
      return false;
    }
    else {

      console.log(this.orderInfo);
      // let cafe24Params = {
      //   access_token: store.cafe24Token,
      //   order_name: args.orderName,
      //   order_amount: args.orderAmount,
      //   return_url: defaultReturnUrl + "/cafeInAppOrderReturnUrl",
      //   automatic_payment: args.automaticPayment
      // }

      let params = {
        store_id: this.store._id,
        teamUser_id: this.teamUser._id,
        orderName: "알림톡 - " + this.orderInfo.name,
        plan: this.orderInfo.val,
        count: this.orderInfo.count,
        addCount: this.orderInfo.addCount,
        orderAmount: this.orderInfo.price,
        orderSaleAmount: Math.floor(this.orderInfo.price * 1.1),
        orderOrgAmount: this.orderInfo.orgPrice,
        serviceAgree: this.orderInfo.serviceAgree,
        privateAgree: this.orderInfo.privateAgree,
        automaticPayment: 'F'
      }


      this.props.updateMsgOrder(params, function(res) {

        if(res.errors && res.errors.length > 0) {
          if(res.errors[0].message === 'fail password') {

          }
          else {
            alert(res.errors[0].message);
          }
        }
        else {
          let name = 'review-widget';
          let specs = 'menubar=no,status=no,toolbar=no';
          let url = res.data.confirmation_url;
          window.open(url, name, specs);

          let timeAfter = 0;
          let iVOrderCheck = setInterval(function() {
            timeAfter = timeAfter+2;
            let isMsgOrderCp = Storage.get('isMsgOrderCp');
            if(isMsgOrderCp === 'end' || timeAfter > 600) {
              clearInterval(iVOrderCheck);
              Storage.remove('isMsgOrderCp');
              _this.props.history.push('/msgOrderList');
            }
          }, 2000);


          //cafeInAppOrderReturnUrl?order_id=cafe24-20230913-446425016&result=fail
        }

      });



    }



  };


  render() {
    const selected = this.orderInfo && this.orderInfo.val ? this.orderInfo : null;
    const allAgreed = selected && this.orderInfo.serviceAgree && this.orderInfo.privateAgree && this.noRefundAgg;

    return (
        <>
        {this.redirectInfo.is ? (
              <Redirect to={{pathname: this.redirectInfo.pathname}} />
          ) : (
            <div className="main-content">
              <PageTitle/>
              {(this.isLogin && this.teamUser.emailId) ? (
                  <div className="msg-order-page">
                    <div className="mo-header">
                      <h2>알림톡 충전</h2>
                      <p>발송 건수 단위로 충전하고 자유롭게 사용하세요. 충전한 건수는 5년간 유효합니다.</p>
                    </div>

                    <div className="mo-section">
                      <div className="mo-section-head">
                        <h3><span className="step">1</span>상품 선택</h3>
                        <span className="head-sub">플랜은 발송 건수 기준으로 책정됩니다.</span>
                      </div>

                      <div className="plan-grid">
                        {this.planPd ? Object.keys(this.planPd).map((key, i) => {
                          const p = this.planPd[key];
                          const totalCount = p.count + p.addCount;
                          const unit = (p.price / totalCount).toFixed(1);
                          const isSelected = this.orderInfo && this.orderInfo.val === key;
                          return (
                            <div key={i}
                                 className={"plan-card" + (isSelected ? " selected" : "")}
                                 onClick={() => this.onSelOrderItem(key)}>
                              <span className="plan-check">✓</span>
                              <div className="plan-name">{p.name}</div>
                              <div className="plan-count-main">
                                {p.label}<span className="unit">건</span>
                              </div>
                              {p.addCount > 0 && (
                                <span className="plan-bonus">+ 보너스 {p.addCount.toLocaleString()}건</span>
                              )}
                              <div className="plan-divider"/>
                              <ul className="plan-rows">
                                <li><span className="label">총 발송건수</span><span className="value">{totalCount.toLocaleString()}건</span></li>
                                <li><span className="label">건당 단가</span><span className="value">{unit}원</span></li>
                                <li><span className="label">정상가</span><span className="value" style={{textDecoration: p.orgPrice !== p.price ? 'line-through' : 'none', color: p.orgPrice !== p.price ? '#9aa3b8' : undefined}}>{p.orgPrice.toLocaleString()}원</span></li>
                                <li className="highlight"><span className="label">할인가</span><span className="value">{p.price.toLocaleString()}원</span></li>
                              </ul>
                              <button className="btn-plan-select" type="button" onClick={(e) => { e.stopPropagation(); this.onSelOrderItem(key); }}>
                                {isSelected ? '선택됨' : '선택하기'}
                              </button>
                            </div>
                          );
                        }) : null}
                      </div>

                      <div className="plan-notice">
                        <ul>
                          <li>표기된 금액은 모두 부가세 별도 금액입니다.</li>
                          <li>충전하신 알림톡은 5년 동안 사용하실 수 있으며, 기한 내 남은 알림톡은 환불 가능합니다.</li>
                          <li>알림톡 환불에 대한 처리는 온리플 이용약관 제 26조에 따릅니다.</li>
                        </ul>
                      </div>
                    </div>

                    <div className="mo-section">
                      <div className="mo-section-head">
                        <h3><span className="step">2</span>약관 동의</h3>
                        <span className="head-sub">아래 약관 내용을 확인 후 모두 동의해주세요.</span>
                      </div>

                      <div className="agree-list-compact">
                        <div className="agree-row-compact">
                          <button type="button" className="agree-title-btn"
                                  onClick={() => this.openTermsModal('service')}>
                            <FeatherIcon icon="file-text" size="14"/>
                            서비스 이용약관
                            <span className="required">(필수)</span>
                          </button>
                          <FormCheckbox toggle small
                                        checked={this.orderInfo.serviceAgree || false}
                                        onChange={event => this.onChangeChecked(event, this.orderInfo, ['serviceAgree'])}/>
                        </div>
                        <div className="agree-row-compact">
                          <button type="button" className="agree-title-btn"
                                  onClick={() => this.openTermsModal('private')}>
                            <FeatherIcon icon="file-text" size="14"/>
                            개인정보 이용약관
                            <span className="required">(필수)</span>
                          </button>
                          <FormCheckbox toggle small
                                        checked={this.orderInfo.privateAgree || false}
                                        onChange={event => this.onChangeChecked(event, this.orderInfo, ['privateAgree'])}/>
                        </div>
                        <div className="agree-row-compact">
                          <button type="button" className="agree-title-btn"
                                  onClick={() => this.openTermsModal('noRefund')}>
                            <FeatherIcon icon="alert-circle" size="14"/>
                            알림톡 상품 환불 정책
                            <span className="required">(필수)</span>
                          </button>
                          <FormCheckbox toggle small
                                        checked={this.noRefundAgg || false}
                                        onChange={event => this.onChangeChecked(event, this, ['noRefundAgg'])}/>
                        </div>
                      </div>
                    </div>

                    {(() => {
                      const m = this.termsModal;
                      if (!m.open) return null;
                      const titleByType = {
                        service: '서비스 이용약관',
                        private: '개인정보 이용약관',
                        noRefund: '알림톡 상품 환불 정책'
                      };
                      const isAgreed = (
                        m.type === 'service' ? !!this.orderInfo.serviceAgree :
                        m.type === 'private' ? !!this.orderInfo.privateAgree :
                        m.type === 'noRefund' ? !!this.noRefundAgg : false
                      );
                      const onToggle = (event) => {
                        if (m.type === 'service')      this.onChangeChecked(event, this.orderInfo, ['serviceAgree']);
                        else if (m.type === 'private') this.onChangeChecked(event, this.orderInfo, ['privateAgree']);
                        else if (m.type === 'noRefund') this.onChangeChecked(event, this, ['noRefundAgg']);
                      };
                      return (
                        <Modal open={m.open}
                               toggle={() => {}}
                               size="lg"
                               className="iao-terms-modal">
                          <ModalHeader toggle={this.closeTermsModal}>
                            <span className="iao-terms-modal__title">
                              <FeatherIcon icon="file-text" size="16"/> {titleByType[m.type] || '약관'}
                            </span>
                          </ModalHeader>
                          <ModalBody>
                            <div className="iao-terms-modal__content">
                              {m.type === 'service' && (
                                <div dangerouslySetInnerHTML={{__html: TermsAndPrivacy.termsOfService}}/>
                              )}
                              {m.type === 'private' && (
                                <div dangerouslySetInnerHTML={{__html: TermsAndPrivacy.privacyPolicy}}/>
                              )}
                              {m.type === 'noRefund' && (
                                <div>
                                  <strong>제 26 조 (알림톡 상품 환불 정책)</strong><br />
                                  ① 사용 내역이 없는 포인트는 전액 결제 취소가 가능합니다.<br/>
                                  ② 결제 취소가 불가한 포인트는 기획재정부에서 고시한 『소비자분쟁해결기준』에 따라 위약금(최종 결제 요금의 10%) 을 공제 후 환불합니다. 단, 남은 금액이 공제금액보다 작은 경우에는 환불할 수 없습니다.<br/>
                                  ③ 환불 시 받은 보너스 건수는 100% 제외 후 환불합니다.<br/>
                                  ④ 환불 시 카드결제가 취소가 어려운 상황에서는 환불에 대한 세금계산서를 제출하여 환불을 요청할 수 있습니다.<br/>
                                  ⑤ 다음과 같은 경우 포인트는 환불되지 않습니다.<br/>
                                  가. 포인트 유효기간 경과한 경우(유효기간 5년)<br/>
                                  나. 회원이 서비스 자진 탈퇴 시 잔여 포인트 환불을 포기한 경우<br/>
                                </div>
                              )}
                            </div>
                            <div className="iao-terms-modal__footer-action">
                              <span className="iao-terms-modal__footer-action-label">
                                내용을 확인하셨다면 동의해주세요.
                              </span>
                              <FormGroup style={{margin: 0}}>
                                <FormCheckbox toggle
                                              checked={isAgreed}
                                              onChange={onToggle}>
                                  {isAgreed ? '동의함' : '동의'}
                                </FormCheckbox>
                              </FormGroup>
                            </div>
                          </ModalBody>
                        </Modal>
                      );
                    })()}

                    <div className="order-summary">
                      <div className="summary-info">
                        {selected ? (
                          <>
                            <span className="summary-pick">{selected.name} · {(selected.count + selected.addCount).toLocaleString()}건</span>
                            <span className="summary-amount">
                              {Math.floor(selected.price * 1.1).toLocaleString()}<span className="cur">원</span>
                              <span className="vat">(VAT 포함)</span>
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="summary-label">선택된 상품 없음</span>
                            <span className="summary-amount">0<span className="cur">원</span></span>
                          </>
                        )}
                      </div>
                      <button type="button"
                              className="order-cta"
                              disabled={!allAgreed}
                              onClick={event => this.onSubmit(event)}>
                        주문하기
                      </button>
                    </div>
                  </div>
              ) : <p className='empty-login'><a href='/signin'>로그인하세요.</a></p>}
            </div>
        )}
        </>
    )
  }
}

export default MsgOrder;
